import { JsonSerializable } from '@/util/object/JsonSerializable'
import { BrandItemResponse } from '@/cowboy/catalog/object/BrandItemResponse'

export class CatalogBrandResponse extends JsonSerializable {
  /** @type {number} */
  #brandID
  /** @type {string} */
  #name
  /** @type {string} */
  #displayKey
  /** @type {string} */
  #brandKey
  /** @type {Object<string, string>} */
  #imageUrls
  /** @type {Array<BrandItemResponse>} */
  #items
  /** @type {string} */
  #description
  /** @type {boolean} */
  #alwaysShowDisclaimer
  /** @type {string} */
  #status
  /** @type {string} */
  #reason
  /** @type {string} */
  #rewardName
  /** @type {string} */
  #displayName
  /** @type {string} */
  #disclaimer
  /** @type {string} */
  #terms
  /** @type {Date} */
  #createdDate
  /** @type {Date} */
  #lastUpdateDate

  constructor (jsonObject) {
    super()
    this.#brandID = Number.parseInt(jsonObject.brandID) || undefined
    this.#name = jsonObject.name
    this.#displayKey = jsonObject.displayKey
    this.#brandKey = jsonObject.brandKey
    this.#imageUrls = jsonObject.imageUrls || {}
    this.#items = jsonObject.items?.map(item => BrandItemResponse.fromJSON(item)) || []
    this.#description = jsonObject.description
    this.#alwaysShowDisclaimer = Boolean(String(jsonObject.alwaysShowDisclaimer).toLowerCase() === 'true')
    this.#status = jsonObject.status
    this.#reason = jsonObject.reason
    this.#rewardName = jsonObject.rewardName
    this.#displayName = jsonObject.displayName
    this.#disclaimer = jsonObject.disclaimer
    this.#terms = jsonObject.terms
    this.#createdDate = new Date(jsonObject.createdDate || undefined)
    this.#lastUpdateDate = new Date(jsonObject.lastUpdateDate || undefined)
    Object.freeze(this)
  }

  get brandID () {
    return this.#brandID
  }

  get name () {
    return this.#name
  }

  get displayKey () {
    return this.#displayKey
  }

  get brandKey () {
    return this.#brandKey
  }

  get imageUrls () {
    return this.#imageUrls
  }

  get items () {
    return this.#items
  }

  get description () {
    return this.#description
  }

  get alwaysShowDisclaimer () {
    return this.#alwaysShowDisclaimer
  }

  /**
   * @deprecated
   * @return {string}
   */
  get status () {
    return this.#status
  }

  /**
   * @deprecated
   * @return {string}
   */
  get reason () {
    return this.#reason
  }

  get rewardName () {
    return this.#rewardName
  }

  get displayName () {
    return this.#displayName
  }

  /**
   * @return {string}
   */
  get disclaimer () {
    return this.#disclaimer
  }

  get terms () {
    return this.#terms
  }

  get createdDate () {
    return this.#createdDate
  }

  get lastUpdateDate () {
    return this.#lastUpdateDate
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      brandID: this.#brandID,
      name: this.#name,
      displayKey: this.#displayKey,
      brandKey: this.#brandKey,
      imageUrls: this.#imageUrls,
      items: this.#items.map(item => item.toJSON()),
      description: this.#description,
      alwaysShowDisclaimer: this.#alwaysShowDisclaimer,
      status: this.#status,
      reason: this.#reason,
      rewardName: this.#rewardName,
      displayName: this.#displayName,
      disclaimer: this.#disclaimer,
      terms: this.#terms,
      createdDate: this.#createdDate?.valueOf() || undefined,
      lastUpdateDate: this.#lastUpdateDate?.valueOf() || undefined
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {CatalogBrandResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new CatalogBrandResponse(jsonObject)) || undefined
  }
}
